/**
 * Route paths for the auth module.
 * Single source of truth — reuse these instead of hard-coding `/`, `/login` and `/forgot-password` strings.
 */
export const AUTH_ROUTES = {
  root: "/",
  login: "/login",
  forgotPassword: "/forgot-password",
} as const;
